<template>
  <div>
    <form v-on:submit.prevent="handleCreateEmailSetting">
      <div>
        <label for="serverApiToken" class="block text-sm font-medium text-gray-700">Server Api Token</label>
        <div class="mt-1 relative rounded-md shadow-sm">
          <input
              @input="v$.emailSetting.serverApiToken.$touch"
              v-model="emailSetting.serverApiToken"
              type="text"
              name="serverApiToken"
              id="serverApiToken"
              class="focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
              placeholder="Token" />
          <div class="mt-1">
            <div
                v-if="v$.emailSetting.serverApiToken.$dirty"
                v-for="error in v$.emailSetting.serverApiToken.$silentErrors"
                :key="error.$uid"
                class="error-msg mt-1 ml-5 text-red-500 font-bold">
              <small>
                {{ error.$message }}
              </small>
            </div>
          </div>
        </div>
        <label for="fromName" class="block text-sm font-medium text-gray-700">From Name</label>
        <div class="mt-1 relative rounded-md shadow-sm">
          <input
              @input="v$.emailSetting.fromName.$touch"
              v-model="emailSetting.fromName"
              type="text"
              name="fromName"
              id="fromName"
              class="focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
              placeholder="Name" />
        </div>
        <div
            v-if="v$.emailSetting.fromName.$dirty"
            v-for="error in v$.emailSetting.fromName.$silentErrors"
            :key="error.$uid"
            class="error-msg mt-1 ml-5 text-red-500 font-bold">
          <small>
            {{ error.$message }}
          </small>
        </div>
        <label for="fromEmail" class="block text-sm font-medium text-gray-700">From Email</label>
        <div class="mt-1 relative rounded-md shadow-sm">
          <input
              @input="v$.emailSetting.fromEmail.$touch"
              v-model="emailSetting.fromEmail"
              type="text"
              name="fromEmail"
              id="fromEmail"
              class="focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
              placeholder="Email" />
          <div
              v-if="v$.emailSetting.fromEmail.$dirty"
              v-for="error in v$.emailSetting.fromEmail.$silentErrors"
              :key="error.$uid"
              class="error-msg mt-1 ml-5 text-red-500 font-bold">
            <small>
              {{ error.$message }}
            </small>
          </div>
        </div>

        <label for="bccEmail" class="block text-sm font-medium text-gray-700">BCC Email</label>
        <div class="mt-1 relative rounded-md shadow-sm">
          <input

              @input="v$.emailSetting.bccEmail.$touch"
              v-model="emailSetting.bccEmail"
              type="text"
              name="bccEmail"
              id="bccEmail"
              class="focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
              placeholder="Email" />
          <div
              v-if="v$.emailSetting.bccEmail.$dirty"
              v-for="error in v$.emailSetting.bccEmail.$silentErrors"
              :key="error.$uid"
              class="error-msg mt-1 ml-5 text-red-500 font-bold">
            <small>
              {{ error.$message }}
            </small>
          </div>
        </div>
        <label for="replyToEmail" class="block text-sm font-medium text-gray-700">Reply To Email</label>
        <div class="mt-1 relative rounded-md shadow-sm">
          <input
              @input="v$.emailSetting.replyToEmail.$touch"
              v-model="emailSetting.replyToEmail"
              type="text"
              name="replyToEmail"
              id="replyToEmail"
              class="focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
              placeholder="Email" />
          <div
              v-if="v$.emailSetting.replyToEmail.$dirty"
              v-for="error in v$.emailSetting.replyToEmail.$silentErrors"
              :key="error.$uid"
              class="error-msg mt-1 ml-5 text-red-500 font-bold">
            <small>
              {{ error.$message }}
            </small>
          </div>
        </div>
        <label for="quill-template" class="block text-sm font-medium text-gray-700">Signature</label>
        <div class="mt-1 relative rounded-md shadow-sm">
          <div id="quill-template" class="mt-1">
            <quill @update:quillBody="setBody" :quillBody="emailSetting.signature" />
          </div>
        </div>
      </div>

      <div class="mt-3">
        <primary-button class="mr-2" @click="handlePreviewSignature" text="Preview" />
        <primary-button :disabled="v$.$invalid" @click="handleCreateEmailSetting" text="Create Email Setting" />
      </div>

      <div class="mt-5">
        <h1 class="text-xl">
          Preview
        </h1>
        <div class="p-2 border border-black">
          <email-preview :preview-content="previewSignature" />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import PrimaryButton from "@/components/Functional/Buttons/PrimaryButton";
import Quill from "@/components/Functional/Quill/Quill";
import EmailPreview from "@/components/Functional/EmailPreview/EmailPreview";
import useVuelidate from '@vuelidate/core'
import { required, email } from '@vuelidate/validators'

export default {
  name: "EmailSettingsForm",
  components: {
    Quill,
    PrimaryButton,
    EmailPreview
  },
  data() {
    return {
      v$: useVuelidate(),
      previewSignature: "Click preview to test",
      previewed: false,
      emailSetting: {
        clientId: parseInt(this.$route.params.id),
        serverApiToken: '',
        fromName: '',
        fromEmail: '',
        bccEmail: '',
        replyToEmail: '',
        signature: ''
      },

    }
  },
  errorCaptured(err, vm, info) {
    this.$store.dispatch('createAlert', {
      type: 'danger',
      message: err
    })
  },
  methods: {
    setBody(body) {
      this.emailSetting.signature = body
    },
    async handlePreviewSignature() {
      this.$store.dispatch('showLoadingSpinner')

      this.errors = []
      try {
        await this.$store.dispatch('previewSignature', { body: this.emailSetting.signature })
        this.previewSignature = this.$store.getters.getPreviewSignature.body
        this.previewed = true
      } catch (e) {
        this.errors = e.response.data.errors
        this.$store.dispatch('createAlert', {
          type: 'danger',
          message: e
        })
      }
      this.$store.dispatch('hideLoadingSpinner')
    },
    async handleCreateEmailSetting() {
      this.$store.dispatch('showLoadingSpinner')

      try {
       await this.$store.dispatch('createEmailSetting', this.emailSetting)
       this.$store.dispatch('createAlert', {
         type: 'success',
         message: 'Email Setting Successfully Created'
       })
     }  catch (e) {
       this.$store.dispatch('createAlert', {
         type: 'danger',
         message: e
       })
     }
      this.$store.dispatch('closeCreateEmailSettingPanel')
      this.$store.dispatch('hideLoadingSpinner')

    }
  },
  validations: {
      emailSetting: {
        serverApiToken: { required },
        fromName: { required },
        fromEmail: { required, email },
        bccEmail: { email },
        replyToEmail: { required, email },
      },
  }
}
</script>

<style scoped>

</style>
